// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Mzxxi","name":"Header_name__kBbhm","birthday":"Header_birthday__3zgq3","skeleton":"Header_skeleton__2pghW"};